"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberStepperAdapter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NumberStepper = require("../NumberStepper");

var _FormikAdapter = require("./FormikAdapter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var NumberStepperAdapter = function NumberStepperAdapter(_ref) {
  var field = _ref.field,
      form = _ref.form,
      atts = _ref.atts,
      cashbotName = _ref.cashbotName,
      label = _ref.label,
      helper = _ref.helper,
      incLabel = _ref.incLabel,
      decLabel = _ref.decLabel,
      isRequiredField = _ref.isRequiredField,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      format = _ref.format,
      usePlusMinus = _ref.usePlusMinus,
      incValue = _ref.incValue,
      light = _ref.light,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      hiddenLabel = _ref.hiddenLabel,
      hiddenHelper = _ref.hiddenHelper;
  return _react.default.createElement(_FormikAdapter.FormikAdapter, {
    field: field,
    form: form,
    options: {
      atts: atts
      /**
       * NOTE: we don't want to pass format to the FormikAdapter for the
       * NumberStepper specifically so we can control only formatting the value
       * that is passed to the underlying input and not the inc/dec controls
       */

    },
    render: function render(props) {
      var _props$atts = props.atts,
          onChange = _props$atts.onChange,
          onBlur = _props$atts.onBlur;

      var handleChange = function handleChange(newValueOrEvent) {
        // depending on whether the value is being changed via the input or through the inc/dec buttons
        // this will receive either the event object or the new string|number value
        if (_typeof(newValueOrEvent) === 'object' && newValueOrEvent.target) {
          onChange(newValueOrEvent);
        } else {
          var touched = form.touched;
          touched[field.name] = true;
          form.setTouched(touched);
          form.setFieldValue(field.name, newValueOrEvent);
        }
      };

      var handleBlur = function handleBlur(newValueOrEvent) {
        onChange(newValueOrEvent);
        onBlur(newValueOrEvent);
      };

      return _react.default.createElement(_NumberStepper.NumberStepper, _extends({}, props, {
        name: field.name,
        onChange: handleChange,
        onBlur: handleBlur,
        label: label,
        helper: helper,
        incLabel: incLabel,
        decLabel: decLabel,
        isRequiredField: isRequiredField,
        cashbotName: cashbotName,
        minValue: minValue,
        maxValue: maxValue,
        format: format,
        usePlusMinus: usePlusMinus,
        incValue: incValue,
        light: light,
        prefix: prefix,
        suffix: suffix,
        hiddenLabel: hiddenLabel,
        hiddenHelper: hiddenHelper
      }));
    }
  });
};

exports.NumberStepperAdapter = NumberStepperAdapter;
NumberStepperAdapter.defaultProps = {
  atts: {
    type: 'tel',
    maxLength: 4
  },
  isRequiredField: true,
  minValue: 1,
  maxValue: Infinity,
  format: null,
  usePlusMinus: false,
  incValue: 1,
  light: false,
  prefix: null,
  suffix: null,
  hiddenLabel: false,
  hiddenHelper: false
};
NumberStepperAdapter.propTypes = {
  field: _propTypes.default.object.isRequired,
  form: _propTypes.default.object.isRequired,
  atts: _propTypes.default.object,
  label: _propTypes.default.string.isRequired,
  helper: _propTypes.default.string.isRequired,
  incLabel: _propTypes.default.string.isRequired,
  decLabel: _propTypes.default.string.isRequired,
  isRequiredField: _propTypes.default.bool,
  cashbotName: _propTypes.default.string.isRequired,
  minValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  maxValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  format: _propTypes.default.func,
  usePlusMinus: _propTypes.default.bool,
  incValue: _propTypes.default.number,
  light: _propTypes.default.bool,
  prefix: _propTypes.default.string,
  suffix: _propTypes.default.string,
  hiddenLabel: _propTypes.default.bool,
  hiddenHelper: _propTypes.default.bool
};